export function awardsLogosSlider() {
    const $slider = $(".awards-logos-slider");
    let isAutoplay = false;
    let speed = parseInt($slider.data('speed'));

    if (speed) {
        isAutoplay = true;
    }

    $slider.slick({
        slidesToScroll: 1,
        slidesToShow: 2.65,
        arrows: false,
        dots: true,
        mobileFirst: true,
        autoplay: isAutoplay,
        autoplaySpeed: speed,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 5
                }
            }
        ]
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/awardsLogosSlider.js